import { render, staticRenderFns } from "./qycxzf.vue?vue&type=template&id=f953c4c8&scoped=true&"
import script from "./qycxzf.vue?vue&type=script&lang=js&"
export * from "./qycxzf.vue?vue&type=script&lang=js&"
import style0 from "./qycxzf.vue?vue&type=style&index=0&id=f953c4c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f953c4c8",
  null
  
)

export default component.exports